import { CircularProgress } from "@material-ui/core";
import React, { useState } from "react";

function Insurence() {
  const [loading, setLoading] = useState(true);
  return (
    <div className="cargo-insurence">
      {loading ? (
        <div className="d-flex justify-content-center align-item-center ">
          <CircularProgress />
        </div>
      ) : null}
      <iframe
        src="https://www.mts-logistics.com/get-cargo-insurance-mobile/"
        frameBorder="0"
        className="gfiframe"
        onLoad={() => {
          // alert(1);
          console.log("loading started");
          setLoading(false);
        }}
      />
      {/* <script src="//www.mts-logistics.com/wp-content/plugins/gravityforms-iframe-master/assets/scripts/gfembed.min.js"
type="text/javascript"></script> */}
    </div>
  );
}

export default Insurence;
